export default __webpack_public_path__ + "static/pig-3b2b1c43432709dc896bbdeecfcec489.png";